import styled from 'styled-components';
import {
  screenSmMax,
  screenXsMax,
  spacer8,
  spacer16,
  spacer24,
  spacer32,
  spacer40,
  gray70,
  gray90,
  cssColorValue,
} from '@spotify-internal/encore-web';
import { Modal as AnchorModal } from '@spotify-internal/anchor-ds';

export const Modal = styled(AnchorModal)`
  && {
    position: relative;
    width: calc(100vw - ${spacer32} - ${spacer32});
    max-width: 978px;

    & > div:first-child {
      justify-content: flex-start;
      margin: ${spacer24} ${spacer16} ${spacer16};

      & > button {
        padding-top: ${spacer8};
      }
    }
    & > div:last-child {
      margin: 0 ${spacer40} ${spacer40} ${spacer40};
    }
  }
`;

export const ModalAsideContent = styled(AnchorModal.AsideContent)`
  padding: 0 ${spacer16};
  font-size: 1.5rem;
  line-height: 2.4rem;
  font-weight: bold;
`;

export const ModalBody = styled(AnchorModal.Body)`
  margin: 0;
  width: 100%;
`;

export const LanguageGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 1px; /* top-bottom 1px padding to give foom for focus border */
  max-height: 455px;
  list-style: none;
  overflow-y: scroll;

  /* 2 columns for small screens */
  @media (max-width: ${screenSmMax}) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* 1 column for mobile web */
  @media (max-width: ${screenXsMax}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const LanguageButton = styled.button`
  display: inline-flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  padding: ${spacer16};
  color: ${cssColorValue('textBase')};

  &:hover {
    background-color: ${gray90};
  }
  &:focus {
    background-color: ${gray90};
  }
`;

export const MutedText = styled.span`
  color: ${cssColorValue('textSubdued')};
`;
